export default "/048cb1f2b29308e18768c65cfd51e426596a830c/d50cc34e778c6c20c755dccf4a153599.svg";